import React from 'react';
import { User as UserIcon } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar';
import { cn } from '@components/lib/utils';

import modifyTextWithLink from '@utils/modifyTextWithLink';
import { createSanitizedMarkup } from '@utils/sanitize';
import { User } from './types';

interface UserInfoProps {
  user: User;
  marginTop: string;
}

const UserInfo: React.FC<UserInfoProps> = ({ user, marginTop }) => {
  const isCentered = user?.backgroundSettings?.avatarAlignmentType === 'center';

  return (
    <div className="mx-auto mb-10 flex w-full max-w-[540px] flex-col">
      <div
        style={{ marginTop }}
        className={cn(
          'flex items-center',
          isCentered ? 'flex-col' : 'flex-row',
        )}
      >
        <div
          className={cn(
            'relative flex flex-col items-center',
            isCentered ? 'mr-0' : 'mr-5',
          )}
        >
          <Avatar className="size-26 max-[743px]:min-w-20">
            <AvatarImage
              src={user?.shareableSettings?.avatar?.url}
              alt={user?.shareableSettings?.fullName}
            />
            <AvatarFallback>
              <UserIcon className="size-10" />
            </AvatarFallback>
          </Avatar>
        </div>
        <div className="w-full">
          <div
            className={cn(
              'relative flex w-fit items-center justify-center',
              isCentered && 'mt-2.5',
            )}
          >
            <h2 className="mr-0 mb-2.5 line-clamp-1 w-full overflow-hidden text-lg font-bold break-all text-foreground">
              {user?.shareableSettings?.fullName}
            </h2>
          </div>
          {user?.tagline ? (
            <p
              className={cn(
                'text-sm whitespace-pre-wrap text-foreground',
                isCentered ? 'text-center' : 'text-start',
              )}
              dangerouslySetInnerHTML={createSanitizedMarkup(
                modifyTextWithLink(
                  user?.tagline,
                  `p p2 ${user?.backgroundSettings?.colorMode} text-color-white`,
                ) || '',
              )}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
